/**
 * Case- and accent-insensitive folding for every user-typed filter in the
 * client (folder tree, move-to-folder picker, in-folder row filter).
 *
 * `toLowerCase()` on its own is not enough. It folds ASCII case but leaves a
 * folder named "Ärchiv" unreachable unless the umlaut is typed exactly, and it
 * misses the Unicode forms mail servers hand back (a name can arrive either
 * pre-composed or as letter + combining mark, and the two are different
 * strings). NFD splits every letter from its combining marks, dropping the
 * marks folds the accent away, and lowercasing finishes the job — so "Ärchiv",
 * "archiv" and "ÄRCHIV" all reduce to the same key.
 *
 * Use this for BOTH sides of a comparison: fold the haystack and the needle.
 */
export function foldText(s: string | null | undefined): string {
    return (s || "").normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
}
